import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appIsFocusableTabIndex',
  pure: true
})
export class IsFocusableTabIndexPipe implements PipeTransform {

  transform(isFocusable: boolean): number {
    return isFocusable ? 0 : -1;
  }
}
